import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { Store } from '@ngrx/store';
import { IStore } from 'src/storage/store';
import * as SearchActions from "../../../../storage/contact-search/search.actions";
import {
  formatTitleCaseWords,
  shouldFormatAsTitleCaseField,
} from "../../utils/text-formatting";

type FilterTagItem ={
  type:string;
  caption:string;
}
@Component({
  selector: 'search-websites-tags-dialog',
  templateUrl: './search-websites-tags-dialog.component.html',
  styleUrls: ['./search-websites-tags-dialog.component.scss']
})
export class SearchWebsitesTagsDialogComponent implements OnInit {

  items:FilterTagItem[];
  removedItems:FilterTagItem[] =[];
  originalItems:FilterTagItem[];

  constructor( public dialogRef: MatDialogRef<SearchWebsitesTagsDialogComponent>,private store: Store<IStore>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.originalItems = data.items;
      this.items = data.items;

  }

  ngOnInit(): void {
  }
  removeItem(value:FilterTagItem){
    this.removedItems.push(value);
    this.items = this.items.filter(obj => obj !== value);
  }
  save(){
    this.dialogRef.close({ items: this.removedItems});
  }
  clear(){
    this.items = [];
    this.store.dispatch(SearchActions.ClearAllAction());
    this.dialogRef.close({ items: undefined});
  }

  displayCaption(item: FilterTagItem): string {
    if (shouldFormatAsTitleCaseField(item.type)) {
      return formatTitleCaseWords(item.caption);
    }

    return item.caption;
  }

}
